var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"deep-badge-pulse-wrap"},[_c('span',{staticClass:"deep-badge-pulse"},[_c('span',{staticClass:"deep-badge-pulse__dot"}),_vm._v(" "+_vm._s(_vm.text)+" ")]),(_vm.showPro)?_c('span',{staticClass:"deep-badge-pulse__pro"},[_vm._v("PRO")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }